import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TuiButton } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

import { ModalContext, ModalFooterComponent, ModalHeaderComponent } from '../modal';

@Component({
  selector: 'ion-no-quit-possible-dialog',
  imports: [ModalHeaderComponent, ModalFooterComponent, TranslateModule, TuiButton],
  templateUrl: './no-quit-possible-dialog.component.html',
  styleUrls: ['./no-quit-possible-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoQuitPossibleDialogComponent {
  readonly context = inject<ModalContext<void, boolean>>(POLYMORPHEUS_CONTEXT);
}
